export const WORKFLOW_ELEMENT_TYPES = {
  WORKFLOW: 'WORKFLOW',
  SCREEN: 'SCREEN',
  SECTION: 'SECTION',
  FIELD: 'FIELD',
  WIDGET: 'WIDGET',
};

export const WORKFLOW_ELEMENT_TYPE_OPTIONS = Object.values(WORKFLOW_ELEMENT_TYPES).map((type) => ({
  label: type,
  value: type,
}));

export const WORKFLOW_ELEMENT_PROPERTY_OPTIONS_SOURCE = {
  STATIC: 'STATIC',
  DYNAMIC: 'DYNAMIC',
};

export const WORKFLOW_ELEMENT_PROPERTY_OPTIONS_SOURCE_OPTIONS = [
  { label: 'Static', value: WORKFLOW_ELEMENT_PROPERTY_OPTIONS_SOURCE.STATIC },
  { label: 'Dynamic (API)', value: WORKFLOW_ELEMENT_PROPERTY_OPTIONS_SOURCE.DYNAMIC },
];

export const WORKFLOW_ELEMENT_PROPERTY_JSON_PATH_PATTERN =
  /^\$?(?:[A-Za-z0-9_$]+)?(?:\.[A-Za-z0-9_$]+|\[(?:\*|\d+|'[^']+'|"[^"]+")\])*$/;

// Request body key per target for /workflow/add_element_properties.
// "filed_properties" is the backend's spelling.
export const WORKFLOW_ELEMENT_PROPERTY_PAYLOAD_KEYS = {
  [WORKFLOW_ELEMENT_TYPES.WORKFLOW]: 'workflow_properties',
  [WORKFLOW_ELEMENT_TYPES.SCREEN]: 'screen_properties',
  [WORKFLOW_ELEMENT_TYPES.SECTION]: 'section_properties',
  [WORKFLOW_ELEMENT_TYPES.FIELD]: 'filed_properties',
  [WORKFLOW_ELEMENT_TYPES.WIDGET]: 'widget_properties',
};
